import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrialFormComponent } from './components/trial-form/trial-form.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { TrialConfirmationComponent } from './components/trial-confirmation/trial-confirmation.component';
import { AuthCallbackComponent } from './components/auth-callback/authCallback.component';
import { ErrorComponent } from './components/error/error.component';
import { PinnacleTrialConfirmationComponent } from './components/pinnacle-trial-confirmation/pinnacle-trial-confirmation.component';
import { TrialProductInfoComponent } from './components/trial-product-info/trial-product-info.component';
import { TrialRegisterAccountComponent } from './components/trial-register-account/trial-register-account.component';

const routes: Routes = [
  { path: '', component: TrialRegisterAccountComponent },
  { path: 'registerTrialAccount', component: TrialRegisterAccountComponent },
  { path: 'trialForm', component: TrialFormComponent },
  { path: 'createAccount', component: CreateAccountComponent },
  { path: 'trialConfirmation', component: TrialConfirmationComponent },
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'pinnacleTrialConfirmation', component: PinnacleTrialConfirmationComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
